<template>
	<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
		@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close>
		<template #default>
			<el-form ref="form" :model="form" label-width="80px" size="mini">
				<el-form-item label="单据编码">
					<el-input disabled v-model="form.paymentcode"></el-input>
				</el-form-item>
				<el-form-item label="收款账号">
					<el-input disabled v-model="form.rcvAcc"></el-input>
				</el-form-item>
				<el-form-item label="收款公司/人">
					<el-input disabled v-model="form.rcvName"></el-input>
				</el-form-item>
				<el-form-item label="应付金额">
					<el-input disabled v-model="form.needamount"></el-input>
				</el-form-item>
				<el-form-item label="凭证号">
					<el-input v-model="form.ddcode"></el-input>
				</el-form-item>
			</el-form>
		</template>
		<template #footer>
			<vxe-button status="primary" content="提交" @click="submit"></vxe-button>
		</template>
	</vxe-modal>
</template>
<style scoped>

</style>
<script>
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [modalMixins],
		props: {
			row: {
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				modal_title: '付款凭证',
				modal_width: 600,
				modal_height: 400,
				tableData: [],
				form: {
					paymentcode: null,
					rcvAcc: null,
					rcvName: null,
					needamount: null,
					ddcode: null
				},
			}
		},
		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			modal_init() {
				this.form.paymentcode = this.row.paymentcode
				this.form.rcvAcc = this.row.rcvAcc
				this.form.rcvName = this.row.rcvName
				this.form.needamount = this.row.needamount
				this.form.ddcode = this.row.ddcode
			},
			modal_hide() {
				this.form.paymentcode = null
				this.form.rcvAcc = null
				this.form.rcvName = null
				this.form.needamount = null
				this.form.ddcode = null
				this.$emit('modalhide')
			},
			submit() {
				this.$api.reconciliation_pay.updatefromlist(this.row.id, {
					ddcode: this.form.ddcode
				}).then(() => {
					this.$emit('success')
					this.$message.success('操作成功')
					this.modal_cancel()
				})
			}
		},
		components: {

		}
	}
</script>